import { createAction } from '../actions';
import modalSelectors from './selectors';
import { WalletSelectors } from '..';


const executeIfPossible = callbackForExecute => {
  if (typeof callbackForExecute !== 'function') {
    return;
  }

  const result = callbackForExecute();

  if (result instanceof Promise) {
    result.catch(console.warn);
  }
};

const SET_TRANSFER_MNEMONIC = createAction('SET_TRANSFER_MNEMONIC');
const SET_BACKUP_MNEMONIC = createAction('SET_BACKUP_MNEMONIC');

const TRANSFER_MNEMONIC_PRE_ACTION = callback => (dispatch, getState) => {
  const state = getState();

  const encryptedMnemonic = WalletSelectors.encryptedMnemonicSelector(state);

  if (!encryptedMnemonic) {
    executeIfPossible(callback);
    return;
  }

  dispatch(SET_TRANSFER_MNEMONIC({ active: true, callback }));
};

const CLOSE_TRANSFER_MNEMONIC = () => dispatch => {
  dispatch(SET_TRANSFER_MNEMONIC({ active: false }));
};

const CLOSE_TRANSFER_MNEMONIC_WITH_CALLBACK = () => (dispatch, getState) => {
  executeIfPossible(modalSelectors.getTransferMnemonicCallback(getState()));

  dispatch(CLOSE_TRANSFER_MNEMONIC());
};

const BACKUP_MNEMONIC_PRE_ACTION = (successCallback, cancelCallback) => SET_BACKUP_MNEMONIC({
  active: true, successCallback, cancelCallback,
});

const BACKUP_MNEMONIC_CONFIRM = () => (dispatch, getState) => {
  executeIfPossible(modalSelectors.gerBackupMnemonicSuccessCallback(getState()));

  dispatch(SET_BACKUP_MNEMONIC({ active: false }));
};

const BACKUP_MNEMONIC_CANCEL = () => (dispatch, getState) => {
  executeIfPossible(modalSelectors.gerBackupMnemonicCancelCallback(getState()));

  dispatch(SET_BACKUP_MNEMONIC({ active: false }));
};

const ModalsActions = {
  TRANSFER_MNEMONIC_PRE_ACTION,
  CLOSE_TRANSFER_MNEMONIC,
  CLOSE_TRANSFER_MNEMONIC_WITH_CALLBACK,
  BACKUP_MNEMONIC_PRE_ACTION,
  BACKUP_MNEMONIC_CONFIRM,
  BACKUP_MNEMONIC_CANCEL,
};

export default ModalsActions;
